/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_Search_CatalogInputs */

const en_fix_search_catalog = /** @type {(inputs: Fix_Search_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search ingredients`)
};

const de_fix_search_catalog = /** @type {(inputs: Fix_Search_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zutaten suchen`)
};

/**
* | output |
* | --- |
* | "Search ingredients" |
*
* @param {Fix_Search_CatalogInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_search_catalog = /** @type {((inputs?: Fix_Search_CatalogInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_Search_CatalogInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_search_catalog(inputs)
	return en_fix_search_catalog(inputs)
});